/**
 * Lazy-load EastSupplier canvas scripts (viewport).
 * All viewports load canvas when near/in view; prefers-reduced-motion skips animation scripts.
 */
(function (win, doc) {
  'use strict';

  var loaded = Object.create(null);

  function skipCanvas() {
    return win.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function loadScript(url) {
    if (loaded[url] === 'done' || loaded[url] === 'loading') return;
    loaded[url] = 'loading';
    var script = doc.createElement('script');
    script.src = url;
    script.async = true;
    script.onload = function () {
      loaded[url] = 'done';
      doc.documentElement.dispatchEvent(
        new CustomEvent('es:canvas-script-loaded', {
          bubbles: true,
          detail: { url: url },
        })
      );
    };
    doc.head.appendChild(script);
  }

  function observe(el) {
    var url = el.getAttribute('data-es-canvas-src');
    if (!url || el.dataset.esCanvasScheduled === '1') return;
    el.dataset.esCanvasScheduled = '1';

    if (skipCanvas()) {
      el.setAttribute('data-es-canvas-skipped', 'reduce-motion');
      return;
    }

    if (el.getAttribute('data-es-canvas-priority') === 'eager') {
      loadScript(url);
      return;
    }

    if (!('IntersectionObserver' in win)) {
      loadScript(url);
      return;
    }

    var rootMargin = '200px 0px';
    if (win.matchMedia('(max-width: 767px)').matches) {
      rootMargin = '320px 0px';
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          loadScript(url);
        });
      },
      { rootMargin: rootMargin, threshold: 0.01 }
    );
    observer.observe(el);
  }

  function boot() {
    doc.querySelectorAll('[data-es-canvas-src]').forEach(observe);
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  doc.addEventListener('shopify:section:load', boot);
})(
  typeof window !== 'undefined' ? window : {},
  typeof document !== 'undefined' ? document : {}
);
